import React, { ReactElement } from 'react'
import { Box, Divider, Flex, ThemeUIStyleObject } from 'theme-ui'
import LogoutIcon from 'images/dashboard/navBar/logout-icon.svg'
import usePresentConfirmLogoutAlert from 'components/Dashboard/utils/usePresentConfirmLogoutAlert'
import { MainNavMenuItems } from 'components/Dashboard/NavBar/NavMenu'
import NavMenuItem from 'components/Dashboard/NavBar/NavMenuItem'
import OrganizationNavMenu from 'components/Organization/OrganizationNavBar/OrganizationNavMenu'
import ImpersonationNavMenu from 'components/Organization/OrganizationNavBar/ImpersonationNavMenu'
import useQueryString from 'utils/useQueryString'
import { useAppSelector } from 'store/hooks'

export enum OrganizationNavRelativePath {
  MY_ORGANIZATION = 'my-org',
  SUB_ORGANIZATIONS = 'sub-orgs',
  BILLING = 'org-billing',
  API = 'api',
  ACCOUNT = 'account',
}

export default function OrganizationNavBarContent(): ReactElement {
  const onLogout = usePresentConfirmLogoutAlert()
  const { qs } = useQueryString()
  const isWarningMessageVisible = useAppSelector(s => s.dashboard.isWarningMessageVisible)

  return (
    <Flex
      sx={{
        position: 'relative',
        width: '100%',
        height: ['auto', '100%'],
        flexDirection: 'column',
        justifyContent: 'space-between',
        px: ['1.2rem', 0],
        flexShrink: [0, 1],
        minHeight: '30rem',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          flexShrink: 0,
          height: ['auto', `calc(100% - 0.2rem - ${isWarningMessageVisible ? '4rem' : '0rem'})`],
        }}
      >
        <Box
          sx={{
            display: ['none', 'block'],
            position: 'absolute',
            width: '100%',
            top: 0,
            pb: '1.6rem',
            background: (theme): string => {
              return `linear-gradient(180deg, ${theme.colors?.blue800} 40%, rgba(18, 19, 28, 0) 100%);`
            },
            zIndex: 'zIndex50',
          }}
        />

        <Flex
          sx={{
            flexDirection: 'column',
            overflowY: 'auto',
            pt: ['1.2rem', '1.6rem'],
            pb: '1.2rem',
          }}
          className="hide-scrollbar"
        >
          {qs.orgId ? <ImpersonationNavMenu /> : <OrganizationNavMenu />}

          <OrgNavMenuDivider />
          <MainNavMenuItems key={qs.orgId} />
          <OrgNavMenuDivider />
          <NavMenuItem onClick={onLogout} activeIcon={LogoutIcon} label="Log out" />
        </Flex>
      </Flex>
    </Flex>
  )
}

const OrgNavMenuDivider = ({ sx }: { sx?: ThemeUIStyleObject }) => (
  <Divider sx={{ my: '0.8rem', color: 'white10', ...sx }} />
)
